import React from 'react';
import { CarLocation } from 'utils/types';

export interface ProviderContext {
  cars: CarLocation[];
  getCarByCallSign: (callsign:string) => CarLocation|null;
}

// @ts-ignore
export default React.createContext<ProviderContext>();